import { gql } from "@apollo/client";

import {
  BUILDING_PARTS_FRAGMENT,
  EXPERT_FRAGMENT,
  LISTING_DEALS_PAGE_FRAGMENT,
  LISTING_DEALS_PAGE_WITH_ITEMS_FRAGMENT,
  LISTING_PARTS_FRAGMENT
} from "./fragments";

export const getDealPageQuery = (saleKey, rentalKey) => gql`
  query(
    $expert_id_input: CampaignInput!
    $sales_type_input: ExpertDealsInput!
    $rentals_type_input: ExpertDealsInput!
  ) {
    experts_program {
      campaign(input: $expert_id_input) {
        active_expert {
          id
          sales: agent_listings(input: $sales_type_input) @connection(key: "${saleKey}") {
            ...ListingDealsPage
          }
          rentals: agent_listings(input: $rentals_type_input) @connection(key: "${rentalKey}") {
            ...ListingDealsPage
          }
        }
      }
    }
  }
  ${LISTING_DEALS_PAGE_FRAGMENT}
`;

export const SALE_ACTIVE_EXPERTS_QUERY = gql`
  query experts_query(
    $segment_input: CampaignInput!
    $contact_ids_input: ExpertsContactsInput!
    $sale_id: ID!
  ) {
    sale(id: $sale_id) {
      ...ListingParts
      building {
        ...BuildingParts
        url
      }
      is_land_lease
      sale_type
    }
    experts_program {
      campaign(input: $segment_input) {
        active_experts_data(input: $contact_ids_input) {
          ...ExpertData
        }
      }
    }
  }
  ${EXPERT_FRAGMENT}
  ${BUILDING_PARTS_FRAGMENT}
  ${LISTING_PARTS_FRAGMENT}
`;

export const BUILDING_ACTIVE_EXPERTS_QUERY = gql`
  query experts_query(
    $segment_input: CampaignInput!
    $contact_ids_input: ExpertsContactsInput!
    $building_id: ID!
  ) {
    building(id: $building_id) {
      ...BuildingParts
    }
    experts_program {
      campaign(input: $segment_input) {
        active_experts_data(input: $contact_ids_input) {
          ...ExpertData
        }
      }
    }
  }
  ${EXPERT_FRAGMENT}
  ${BUILDING_PARTS_FRAGMENT}
`;

export const getTypePageQuery = key => gql`
  query(
    $expert_id_input: CampaignInput!
    $deals_type_input: ExpertDealsInput!
  ) {
    experts_program {
      campaign(input: $expert_id_input) {
        active_expert {
          id
          agent_listings(input: $deals_type_input) @connection(key: "${key}") {
            ...ListingDealsPageWithItems
          }
        }
      }
    }
  }
  ${LISTING_DEALS_PAGE_WITH_ITEMS_FRAGMENT}
`;
